import { http } from '@frontend/fetch';
import { sentry } from '@frontend/tracking';
import { IntakeFormLocation } from './types';
import { IntakeFormStore } from './use-intake-form-store';

export const logOnboardingSentryError = (errorMessage: string, error?: unknown) => {
  if (error) {
    // ignoring 401 API errors
    if (http.isHttpError(error) && error.status === 401) {
      return;
    }
    console.error(error);
  }

  sentry.error({ team: 'fe-clm', error: errorMessage, topic: 'onboarding' });
};

export type PrepareIntakeFormStoreInfoFromLocationList = (args: {
  intakeFormLocations?: IntakeFormLocation[];
  userEmail?: string;
  isParentLocation?: boolean;
  isWeaveUser?: boolean;
  selectedLocationIds?: string[];
}) => Pick<IntakeFormStore, 'intakeFormLocations' | 'ownIntakeFormLocations' | 'isShowIntakeForm'> & {
  ownIncompleteIntakeForms: IntakeFormLocation[];
};

export const prepareIntakeFormStoreInfoFromLocationList: PrepareIntakeFormStoreInfoFromLocationList = ({
  intakeFormLocations = [],
  userEmail = '',
  isParentLocation = false,
  isWeaveUser = false,
  selectedLocationIds = [],
}) => {
  const selectedIntakeFormLocations = intakeFormLocations.filter(
    (location) => selectedLocationIds.includes(location.locationId) && !location.error
  );
  const incompleteIntakeForms = selectedIntakeFormLocations.filter(({ formCompletedAt }) => !formCompletedAt);
  // TODO: remove own intake forms logic once fastpass is enabled for all multi locations
  const ownIntakeFormLocations = selectedIntakeFormLocations.filter((location) => {
    // If fast pass is eligible any user can see the intake form
    // If not, only the onboarding contact email or Weave users can see the intake form
    return (
      location.isFastPassEligibleLocation ||
      !location.onboardingContactEmail ||
      location.onboardingContactEmail === userEmail ||
      isWeaveUser
    );
  });

  const ownIncompleteIntakeForms = ownIntakeFormLocations.filter(({ formCompletedAt }) => !formCompletedAt);
  const hasOwnIncompleteIntakeForms = ownIncompleteIntakeForms.length > 0;
  const hasIncompleteIntakeForms = incompleteIntakeForms.length > 0;

  const isShowIntakeForm = isParentLocation ? hasOwnIncompleteIntakeForms : hasIncompleteIntakeForms;

  return {
    intakeFormLocations: selectedIntakeFormLocations,
    ownIntakeFormLocations,
    ownIncompleteIntakeForms,
    isShowIntakeForm,
  };
};
